module.exports = __webpack_public_path__ + "img/convenience_store.9864124d.png";